<template>
	<div class="tool-wrap">
    <button class="tool__button" @click="openPanel"><Icon :icon="this.icon"></Icon><span class="tool__button-text">{{ title }}</span></button>
	</div>
</template>

<script>

/**
 * Modal JSFiddle
 * https://jsfiddle.net/yyx990803/mwLbw11k/?utm_source=website&utm_medium=embed&utm_campaign=mwLbw11k
 *
 * Repeater JSFiddle
 * https://jsfiddle.net/cr8vfgrz/10/
 */

import Icon  from './Icon.vue'

export default {

  /**
   * COMPONENTS
   * ----------
   * 
   * These are the components that can be used by this 
   * component
   */
  
  components: {
    Icon
  },  

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    openPanel() {

      this.$parent.$data.subpanel.title = this.title;
      this.$parent.$data.subpanel.context = this.context;
      this.$parent.$data.subpanel.icon = this.icon;
      this.$parent.$data.subpanel.view  = 'toolPanel';      

      this.$parent.$data.subpanel.state = 'active';

      this.$store.dispatch('setCurrentTool', this.context);      

    },

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

  
  },

  props : [
    'context',
  	'title',
    'icon',    
  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .tool-wrap {

    &:first-of-type {

      .tool__button {

        border-width: 0;

      }

    }

  }

  .tool__button {

    -webkit-appearance: none;
    background: none;
    border: 0;
    width: calc(100% + 6rem);
    text-align: left;
    outline: none;

    margin: 0 -3rem;
    padding: 1rem 3rem;

    border-top: 1px solid #e2e2e2;

    &:hover,
    &:focus,
    &:active {

      background-color: #e2e2e2;

      .icon {

        transform: scale(1);

      }

    }

    .icon { 

      display: inline-block;
      vertical-align: top;
      width: 2.25rem;
      height: 2.25rem;
      margin-right: .75rem;
      transform: scale(.8);
      transition: transform .15s ease;

      .icon__svg {

        stroke: #06a0df;

      }      

    }

  }

  .tool__button-text {

    font-size: .8rem;
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 3rem);
    padding-top: .5rem;

  }

</style>



// WEBPACK FOOTER //
// Tool.vue?125d1699